<div class="step-container">
    <h1 class="text-tertiary-900">Step Two</h1>

    <h2 class="text-tertiary-900">Enter Specifics</h2>

    <img
        src="assets/svg/cevo-go-enter-data.svg"
        alt="Check list"
        class="hero-image"
    />

    <p>
        Provide minimum system information for shared or exclusive frequencies.
    </p>

    <p>Cevo Go provides optimum results to suit your needs.</p>
</div>
